// src/components/layout/Footer.tsx
import React from 'react';
import './Layout.css'; // We'll share the CSS with Layout
import { useUniqueUserId } from '../../contexts/UniqueUserIdContext'; // The new hook
// Import the package.json file
import packageJson from '../../../package.json'; // Adjust the path if needed

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const uniqueUserId = useUniqueUserId(); // Get the device/browser ID
  const appVersion = packageJson.version; // Get the version from the imported JSON

  return (
    <footer className="layout-footer">
      {/* First item - aligned left */}
      <p>&copy; {currentYear} Deriq AI v{appVersion}. All rights reserved.</p> {/* Display version here */}

      {/* Second item - aligned right */}
      {uniqueUserId && <p>ID: {uniqueUserId}</p>}
    </footer>
  );
};

export default Footer;
